import React, {useEffect} from 'react'
// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import styled, {css} from 'styled-components'
import OurStory_topArea from '../../assets/images/OurStory_topArea_taller.jpg'
import OurStory_topAreaBg from '../../assets/images/OurStory_topArea_left.jpg'
import OurStory_topAreaBgRight from '../../assets/images/OurStory_topArea_bg.jpg'
import OurStory_Title from '../../assets/images/OurStory_Title.svg'
import Breakpoint from '../../utils/breakpoint'
import Font from '../../utils/Font'
import {Box, BoxWrapper} from './styles'

const {mobile, desk} = Breakpoint

const chineseLang = ['zh-tw', 'zh-cn']
const otherLangsMap = [...chineseLang, 'ja']
const frenchMap = ['fr']

const Wrapper = styled.div`
  background-image: url('${OurStory_topAreaBg}');
  background-repeat: repeat-x;
  background-position: 50% 50%;
  background-size: auto 100%;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    height: 100%;
    background-image: url('${OurStory_topAreaBgRight}');
    background-repeat: repeat-x;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
`
const Container = styled.div`
  position: relative;
  background-image: url('${OurStory_topArea}');
  min-height: 810px;
  height: 46vw;
  background-position: 50% 50%;
  background-size: auto 100%;
  //background-color: #42abda;
  background-repeat: no-repeat;
  @media (max-width: ${mobile}px) {
    background-repeat: no-repeat;
    background-size: auto 67%;
    background-position: 50% 100%;
    background-color: #42abda;
    min-height: 140vw;
  }
`
interface LabelProps {
  readonly langCode: string
}
const Label = styled.h1<LabelProps>`
  font-family: ${({langCode}) => Font(langCode).mainFont};
  color: #fff2b2;
  margin: 0 0 3rem;
  padding-top: ${({langCode}) => (chineseLang.indexOf(langCode) > -1 ? '5.9' : '5')}rem;
  text-align: center;
  line-height: 1.2em;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.45);
  @media (max-width: ${mobile}px) {
    margin-bottom: 2rem;
    padding-top: 3rem;
  }
  & .Main_Label_Line1 {
    font-style: italic;
    font-size: 40px;
    padding-bottom: 10px;
    @media (max-width: ${mobile}px) {
      font-size: 25px;
      line-height: 1em;
      padding-bottom: 0;
    }
  }
`
const Strong = styled.div`
  font-size: 65px;
  font-weight: 400;
  margin-top: -5px;
  @media (max-width: ${mobile}px) {
    font-size: 44px;
  }
`
interface IntroductionProps {
  readonly langCode: string
}
const Introduction = styled.div<IntroductionProps>`
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  font-family: ${({langCode}) => Font(langCode).bodyFont};
  line-height: 1.56;
  font-size: 20.8px;
  ${({langCode}) =>
    otherLangsMap.indexOf(langCode) < 0 &&
    css`
      text-shadow: 0 0 5px #fff;
    `}
  ${({langCode}) =>
    frenchMap.indexOf(langCode) >= 0 &&
    css`
      text-shadow: 0 0 5px #fff;
    `}
  @media (max-width: ${mobile}px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`
// https://segmentfault.com/a/1190000020536678
interface IProps {
  introduction: any
  translation: any
  langCode: string
  title: string
  // onClick(event: React.MouseEvent<HTMLButtonElement>): void
  // ...
}

const TopSection: React.FC<IProps> = ({introduction, translation, langCode, title}) => {
  // const content = useSelector((state: RootState) => state.main.contentData)
  // const loading = useSelector((state: RootState) => state.main.loading)
  // const error = useSelector((state: RootState) => state.main.error)
  // const dispatch = useDispatch()

  // useEffect(() => {}, [])

  const mainLanguage = otherLangsMap.indexOf(langCode) < 0
  const isChineseLang = chineseLang.indexOf(langCode) > -1
  // interface IProps {
  //   isChineseLang: boolean
  // }

  return (
    <Wrapper>
      <Container>
        <Label langCode={langCode}>
          {langCode === 'en-us' ? (
            <>
              <div className="Main_Label_Line1">{translation['Our']}</div>
              <Strong>{translation['Story']}</Strong>
            </>
          ) : (
            <>
              {isChineseLang ? (
                <BoxWrapper>
                  <Box>
                    <img src={OurStory_Title} alt={title} />
                  </Box>
                </BoxWrapper>
              ) : (
                <div className="Main_Label_LineAll" dangerouslySetInnerHTML={{__html: title}} />
              )}
            </>
          )}
        </Label>
        <Introduction className="Paragraph" langCode={langCode} dangerouslySetInnerHTML={{__html: introduction}} />
        <div className="view-width-detect" />
      </Container>
    </Wrapper>
  )
}

export default TopSection
